import React from 'react'
import t from 'prop-types'
import { css } from 'linaria'
import LinkWithIcon from '../../Links/LinkWithIcon/LinkWithIcon'
import cx from 'classnames'

const sectionHeader = css`
  &:after {
    content: '';
    height: 2px;
    @apply block mt-2 bg-gray-700;
  }

  &.isOnDarkBg {
    &:after {
      @apply bg-gray-100;
    }
  }

  @screen md {
    &:after {
      width: calc(100% + theme('spacing.10'));
    }
  }
`

const subheadingCSS = css`
  a {
    @apply text-blue-100;
    &:hover {
      @apply text-blue-50;
    }
  }
`

const SectionHeader = ({
  as,
  heading,
  isOnDarkBg,
  linkWithIcon,
  subheading,
  id,
}) => {
  const Element = as
  return (
    <div
      className={cx({
        'text-gray-700': !isOnDarkBg,
        'text-white': isOnDarkBg,
      })}
    >
      {heading && (
        <div className="flex flex-col md:flex-row justify-between">
          <Element
            id={id}
            className={cx(
              sectionHeader,
              'mb-4 md:mb-0 text-xl md:text-2xl font-semibold inline-block leading-tight capitalize',
              { isOnDarkBg: isOnDarkBg }
            )}
          >
            {heading}
          </Element>
          {linkWithIcon && <LinkWithIcon {...linkWithIcon}></LinkWithIcon>}
        </div>
      )}
      {subheading && (
        <div
          className={cx(
            subheadingCSS,
            'text-2xl font-semibold md:text-3xl max-w-screen-lg leading-tight',
            { 'mt-12': heading }
          )}
          dangerouslySetInnerHTML={{ __html: subheading }}
        />
      )}
    </div>
  )
}

SectionHeader.propTypes = {
  as: t.string,
  heading: t.string,
  isOnDarkBg: t.bool,
  linkWithIcon: t.object,
  subheading: t.string,
}

SectionHeader.defaultProps = {
  as: 'h2',
  isOnDarkBg: false,
  linkWIthIcon: null,
}

export default SectionHeader
